/**
 * Checkout Consent Guard
 * Prevents checkout if user hasn't accepted cookies (only did age verification)
 */

class CheckoutConsentGuard {
  constructor() {
    this.cookieName = 'cookie_consent';
    this.init();
  }

  /**
   * Initialize the checkout guard
   */
  init() {
    this.bindCheckoutButtons();
  }

  /**
   * Bind click handlers to checkout buttons
   */
  bindCheckoutButtons() {
    // Handle both regular checkout buttons and cart drawer checkout buttons
    const checkoutButtons = document.querySelectorAll('[data-cart-checkout], .checkout-button, [href*="/checkout"]');
    
    checkoutButtons.forEach(button => {
      button.addEventListener('click', (evt) => {
        if (!this.hasConsent()) {
          evt.preventDefault();
          this.showConsentRequired();
        }
      });
    });
  }

  /**
   * Check if user has given cookie consent
   */
  hasConsent() {
    return this.getCookie(this.cookieName) !== null;
  }

  /**
   * Show message that consent is required
   */
  showConsentRequired() {
    // Try to open the cookie consent modal if it exists
    const cookieModal = document.getElementById('cookie-consent-modal');
    
    if (cookieModal) {
      const instance = window.cookieConsentInstance;
      if (instance && typeof instance.setModalContent === 'function') {
        instance.setModalContent('age_notice');
        instance.open();
        return;
      }

      cookieModal.setAttribute('open', '');
      cookieModal.style.display = 'block';
      return;
    }

    // Fallback to alert if modal not available
    alert('Please accept cookies to proceed with checkout.');
  }

  /**
   * Get cookie helper (copied from cookie-consent.js)
   */
  getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CheckoutConsentGuard();
});

// Also initialize immediately in case DOM is already loaded
if (document.readyState === 'loading') {
  // DOM is still loading, the DOMContentLoaded listener will handle it
} else {
  // DOM is already loaded
  new CheckoutConsentGuard();
} 